import React, { useState, useEffect } from "react";
import { bool, string, func } from "prop-types";
import get from "lodash/get";
import { Icon } from "../../atoms/icon";
import { RadioButton } from "../../atoms/radio-button";
import Button from "../../atoms/Button";
import "./communication-preferences-confirmation-modal.m.css";
import { COMMUNICATION_PREFERENCES_CONTENT, NOTIFICATION_PREFERENCES } from "../../../constants";

export const CommunicationPreferencesConfirmationModal = ({
  isOpen,
  onClose,
  selectedPreference,
  subscriberMetadata,
  onConfirm,
  onPreferenceChange,
  selectedDirectorySharing,
  onDirectorySharingChange,
  className = "",
  ...props
}) => {

  if (!isOpen) return null;

  const handleCommunicationChange = (e) => {
    if (onPreferenceChange) {
      onPreferenceChange(e.target.value);
    }
  };

  const handleDirectoryChange = (e) => {
    if (onDirectorySharingChange) {
      onDirectorySharingChange(e.target.value);
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm({
        communicationPreference: selectedPreference,
        directorySharing: selectedDirectorySharing
      });
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div styleName="modal-overlay" className={className} onClick={handleOverlayClick} {...props}>
      <div styleName="modal-content">
        <button styleName="close-button" onClick={onClose} type="button">
          <Icon name="close" size="xsmall" />
        </button>

        <div styleName="modal-header">
          <h2 styleName="modal-title">{COMMUNICATION_PREFERENCES_CONTENT.MODAL_TITLE}</h2>
        </div>

        <div styleName="modal-body">
          {/* Email Preferences Section */}
          <div styleName="preferences-section">
            <p styleName="section-description">
              {COMMUNICATION_PREFERENCES_CONTENT.EMAIL_DESCRIPTION}
            </p>

            <div styleName="preferences-options">
              {NOTIFICATION_PREFERENCES.map((preference) => (
                <label key={preference.value} styleName="preference-option">
                  <RadioButton
                    name="communication-preference"
                    value={preference.value}
                    checked={selectedPreference === preference.value}
                    onChange={handleCommunicationChange}
                  />
                  <span styleName="option-label">{preference.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Directory Sharing Section */}
          <div styleName="directory-section">
            <p styleName="directory-description">
              {COMMUNICATION_PREFERENCES_CONTENT.DIRECTORY_DESCRIPTION}
            </p>

            <div styleName="directory-options">
              <label styleName="directory-option">
                <RadioButton
                  name="directory-sharing"
                  value="yes"
                  checked={selectedDirectorySharing?.toLowerCase() === "yes"}
                  onChange={handleDirectoryChange}
                />
                <span styleName="option-label">{COMMUNICATION_PREFERENCES_CONTENT.YES_OPTION}</span>
              </label>

              <label styleName="directory-option">
                <RadioButton
                  name="directory-sharing"
                  value="no"
                  checked={selectedDirectorySharing?.toLowerCase() === "no"}
                  onChange={handleDirectoryChange}
                />
                <span styleName="option-label">{COMMUNICATION_PREFERENCES_CONTENT.NO_OPTION}</span>
              </label>
            </div>
          </div>

          <p styleName="disclaimer-text">
            {COMMUNICATION_PREFERENCES_CONTENT.DISCLAIMER_TEXT}
          </p>

          <Button
            variant="dark"
            onClick={handleConfirm}
            styleName="confirm-button"
          >
            {COMMUNICATION_PREFERENCES_CONTENT.CONFIRM_BUTTON}
          </Button>
        </div>
      </div>
    </div>
  );
};

CommunicationPreferencesConfirmationModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  selectedPreference: string.isRequired,
  onConfirm: func.isRequired,
  onPreferenceChange: func,
  onDirectorySharingChange: func,
  className: string
};